import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import CaluModal from '@/components/CaluModal'
import LoaderCircle from '@/components/LoaderCircle'
import CaluButton from '@/components/styledComponents/CaluButton'
import { SUBSCRIPTION_PAYMENT_SELECTED } from '@/store/subscriptionPayments'
import { getAllSubscriptionPayments, updateSubscriptionPayment } from '@/store/subscriptionPayments/actions'
import { formatAmount } from '@/utils/functions/formatAmount'
import { showToast } from '@/utils/toast'

import dayjs from 'dayjs'
import { handleCalculateFinalPrice } from '../functions/handleCalculateFinalPrice'
import { handleFindPlanPrice } from '../functions/handleFindPlanPrice'
import PaymentsTable from './PaymentsTable'
import VoucherPopUp from './VoucherPopUp'

import s from './styles.module.scss'

const InfoPayments = () => {
  const dispatch = useDispatch()

  const [dataVoucher, setDataVoucher] = useState(null)
  const [openVoucherPopUp, setOpenVoucherPopUp] = useState(false)
  const [confirmPendingToPaid, setConfirmPendingToPaid] = useState(false)
  const [loadingPendingToPaid, setLoadingPendingToPaid] = useState(false)

  const { centreAdminDetail } = useSelector((state) => state?.centres)
  const { allPlanPrices } = useSelector((state) => state?.planPrices)
  const { isLoading } = useSelector((state) => state?.subscriptionPayments)

  const centreConfiguration = centreAdminDetail?.centreConfiguration

  const { allSubscriptionPayments } = useSelector((state) => state?.subscriptionPayments)
  const paymentLinkMP = centreConfiguration?.mercadoPagoPreapprovalPlanInitPoint

  useEffect(() => {
    setInit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setInit = async () => {
    const params = {
      centre: centreAdminDetail._id,
    }
    await dispatch(getAllSubscriptionPayments(params))
  }

  const handleDisabledButton = () => {
    if (!centreConfiguration) return true
    if (
      !centreConfiguration?.subscriptionPlan ||
      !centreConfiguration?.subscriptionAgendasQuantity ||
      !centreConfiguration?.subscriptionPaymentType
    )
      return true
    return false
  }

  const handleGenerateVoucher = async () => {
    dispatch(SUBSCRIPTION_PAYMENT_SELECTED(null))

    const suggestedPrice = handleFindPlanPrice(
      allPlanPrices,
      centreAdminDetail?.country || 'ARG',
      centreConfiguration?.subscriptionPlan,
      centreConfiguration?.subscriptionAgendasQuantity,
    )

    const finalPrice = handleCalculateFinalPrice(
      suggestedPrice,
      centreConfiguration?.subscriptionExtraAmount?.type,
      centreConfiguration?.subscriptionExtraAmount?.value,
    )

    const dataVoucher = {
      centre: { _id: centreAdminDetail._id, name: centreAdminDetail?.name },
      subscriptionPlan: centreConfiguration?.subscriptionPlan,
      subscriptionAgendasQuantity: centreConfiguration?.subscriptionAgendasQuantity,
      subscriptionExtraAmount: centreConfiguration?.subscriptionExtraAmount,
      subscriptionPaymentType: centreConfiguration?.subscriptionPaymentType,
      currency: centreAdminDetail?.country || 'ARG',
      amount: finalPrice,
    }

    setDataVoucher(dataVoucher)
    setOpenVoucherPopUp(true)
  }

  // funcion que paso los estados pending a pagado

  const handlePendingToPaid = async () => {
    const unpaidPayments = allSubscriptionPayments?.filter(
      (item) => item.paymentStatus === 'pending' || item.paymentStatus === 'partiallyPaid',
    )

    if (!unpaidPayments.length) return

    try {
      setLoadingPendingToPaid(true)
      for (const item of unpaidPayments) {
        const payload = {
          ...item,
          paymentStatus: 'paid',
          paidAmount: item.amount,
          paymentDate: dayjs().utc(true).startOf('day').toISOString(),
        }
        await dispatch(updateSubscriptionPayment(payload, true))
      }
      showToast('Pagos actualizados correctamente', 'success')
      setLoadingPendingToPaid(false)
    } catch (err) {
      showToast('Ocurrió un error al actualizar los pagos', 'error')
      setLoadingPendingToPaid(false)
    }
  }

  const subscriptionPaymentDebt = () => {
    const debt = allSubscriptionPayments?.reduce((acc, payment) => {
      if (payment.paymentStatus === 'pending' || payment.paymentStatus === 'partiallyPaid') {
        return acc + (payment.amount - (payment?.paidAmount || 0))
      }
      return acc
    }, 0)
    return formatAmount(debt)
  }

  return (
    <div className={s.mainContainer}>
      {isLoading ? (
        <LoaderCircle size={50} />
      ) : (
        <div>
          <PaymentsTable
            setOpenVoucherPopUp={setOpenVoucherPopUp}
            setConfirmPendingToPaid={setConfirmPendingToPaid}
            loadingPendingToPaid={loadingPendingToPaid}
          />
          <div className={s.contButtons}>
            <div>
              <div>
                <b>Deuda total: </b>
                <span>{`$${subscriptionPaymentDebt()}`}</span>
              </div>
              {paymentLinkMP && (
                <span>
                  <button
                    type="button"
                    className={s.linkMP}
                    onClick={() => {
                      navigator.clipboard.writeText(paymentLinkMP)
                      showToast('Link de pago copiado al portapapeles', 'success')
                    }}
                  >
                    Copiar link de suscripción🔗
                  </button>
                </span>
              )}
            </div>
            <CaluButton
              color="primary"
              size="medium"
              onClick={() => handleGenerateVoucher()}
              disabled={handleDisabledButton()}
            >
              Generar cupón de pago
            </CaluButton>
          </div>
        </div>
      )}

      {openVoucherPopUp && (
        <VoucherPopUp open={openVoucherPopUp} setOpen={setOpenVoucherPopUp} dataVoucher={dataVoucher} />
      )}

      <CaluModal
        open={confirmPendingToPaid}
        setOpen={setConfirmPendingToPaid}
        maxWidth="sm"
        fullWidth
        textConfirmationButton="Confirmar"
        onClose={() => {
          handlePendingToPaid()
          setConfirmPendingToPaid(false)
        }}
        title={'Confirmar actualización de pagos'}
      >
        <div>
          <p>
            Todos los pagos con estado pendiente o pago parcial serán actualizados a pagado.
            <b> Deuda total registrada: </b> {` $${subscriptionPaymentDebt()}`}
          </p>
        </div>
      </CaluModal>
    </div>
  )
}

export default InfoPayments
